import Button from '../../sharedComponents/Button/Button';
import Heading from '../../sharedComponents/Heading/Heading';
import './ResearchPage.scss';
import Image1 from '../../../assets/ResearchAutomobile.svg';
import Image2 from '../../../assets/ResearchImage1.svg';
import Image3 from '../../../assets/ResearchImage2.svg';
import Image4 from '../../../assets/media-generation.svg';
import Input from '../../sharedComponents/Input/Input';
import { ReactComponent as ArrowForward } from '../../../assets/icons/arrow_forward.svg';
import RocketIcon from '../../../assets/icons/rocket.svg';
import { useEffect, useState } from 'react';
import { useEmailJS } from '../../coreModules/hooks/useEmaiJs';
function ResearchPage() {
    const INITIAL_FORM_DATA = {
        message: '',
        email: '',
        experience: ''
    }
    const [formData, setFormData] = useState(INITIAL_FORM_DATA);
    const [errorData, setErrorData] = useState(INITIAL_FORM_DATA);
    const [isBtnDisabled, setBtnDisabled] = useState(true);

    const handleInputChange = (key: string, value: string) => {
        if (value === '') {
            setErrorData((prevState) => ({
                ...prevState,
                [key]: `Enter value for ${key}`
            }))
        }
        else {
            setErrorData((prevState) => ({
                ...prevState,
                [key]: ``
            }))
        }
        const newFormData = {
            ...formData,
            [key]: value

        }
        setFormData(newFormData);
        const isValidEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(newFormData?.email?.trim());
        const isValidMessage = /^.{5,1000}$/.test(newFormData?.message?.trim());
        const isValidExperience = /^[0-9]/.test(newFormData?.experience);
        if (!isValidEmail && key === 'email') {
            setErrorData((prevState) => ({
                ...prevState,
                email: 'Enter valid email address'
            }))
        }
        if (!isValidMessage && key === 'message') {
            setErrorData((prevState) => ({
                ...prevState,
                message: 'Enter valid message'
            }))
        }
        if (!isValidExperience && key === 'experience') {
            setErrorData((prevState) => ({
                ...prevState,
                experience: 'Enter Valid Experience'
            }))
        }
        if (isValidEmail && isValidMessage) {
            setBtnDisabled(false);
        }
    }

    const { isLoading, error, sendEmail, success } = useEmailJS({
        serviceId: process.env.REACT_APP_EMAILJS_SERVICE_ID_CAREERS!,
        templateId: process.env.REACT_APP_EMAILJS_TEMPLATE_ID_CAREERS!,
        publicKey: process.env.REACT_APP_EMAIL_JS_PUBLIC_KEY!,
        formData,
    });


    const handleSubmit = async () => {
        const isValidEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(formData.email?.trim());
        const isValidMessage = /^.{5,1000}$/.test(formData.message?.trim());

        if (isValidEmail && isValidMessage) {
            setBtnDisabled(false);
            try {
                await sendEmail();
            } catch (error) {
                console.error('Error sending email:', error);
            }
        }
    };

    useEffect(() => {
        if (success) {
            window.alert('Mail Sent Successfully!');
            setFormData(INITIAL_FORM_DATA);
            setErrorData(INITIAL_FORM_DATA);
        }
    }, [success])

    const goToContent = () => {
        const element = document.getElementById('research-content');

        if (element) {
            const y = element.getBoundingClientRect().top + window.scrollY;

            window.scrollTo({
                top: y,
                behavior: 'smooth',
            });
        }
    }

    return (
        <div className='alpha-perceptron-research-page'>
            <div className='alpha-perceptron-research-page__section-one'>
                <div className='alpha-perceptron-research-page__section-one__content'>
                    <Heading size='h1' type='primary' theme='dark'>
                        Our Research
                    </Heading>
                    <Heading size='h2' type='primary' theme='dark'>
                        Shaping the Future of AI
                    </Heading>
                    <Heading size='h6' type='secondary' theme='dark'>
                        At AlphaPerceptron, we are committed to pushing the boundaries of artificial intelligence.
                    </Heading>
                    <Button onClick={goToContent} type='primary' theme='dark'>
                        Read More
                    </Button>
                </div>
            </div>
            <div id='research-content' className='alpha-perceptron-research-page__section'>
                <div className='alpha-perceptron-research-page__section__image'>
                    <img src={Image3} alt='AlphaPerceptron' />
                </div>
                <div className='alpha-perceptron-research-page__section__content'>
                    <Heading theme='dark' size='h3' type='primary'>
                        Humanoid Robotics
                    </Heading>
                    <Heading theme='dark' size='h6' type='secondary'>
                        Bringing AI-powered robotic assistants closer to reality.
                    </Heading>
                    <div className='alpha-perceptron-research-page__section__content__flexRows'>
                        <div className='alpha-perceptron-research-page__section__content__flexRows__containers'>
                            <Heading theme='dark' size='h7' type='secondary'>
                                Advancing human-like dexterity and motion in robotics.
                            </Heading>
                        </div>
                        <div className='alpha-perceptron-research-page__section__content__flexRows__containers'>
                            <Heading theme='dark' size='h7' type='secondary'>
                                Developing AI-driven interaction models for seamless communication.
                            </Heading>
                        </div>
                        <div className='alpha-perceptron-research-page__section__content__flexRows__containers'>
                            <Heading theme='dark' size='h7' type='secondary'>
                                Integrating multi-modal learning for robots to adapt and learn from humans.
                            </Heading>
                        </div>
                    </div>
                </div>
            </div>
            <div className='alpha-perceptron-research-page__section'>
                <div className='alpha-perceptron-research-page__section__content'>
                    <Heading theme='dark' size='h3' type='primary'>Autonomous Intelligence</Heading>
                    <Heading theme='dark' size='h6' type='secondary'>Developing AI systems capable of self-learning, reasoning, and decision-making.</Heading>
                    <div className='alpha-perceptron-research-page__section__content__flexRows'>
                        <div className='alpha-perceptron-research-page__section__content__flexRows__containers'>
                            <Heading theme='dark' size='h7' type='secondary'>
                                Enhancing autonomous navigation for self-driving vehicles.
                            </Heading>
                        </div>
                        <div className='alpha-perceptron-research-page__section__content__flexRows__containers'>
                            <Heading theme='dark' size='h7' type='secondary'>
                                Exploring reinforcement learning for adaptive AI systems.
                            </Heading>
                        </div>
                        <div className='alpha-perceptron-research-page__section__content__flexRows__containers'>
                            <Heading theme='dark' size='h7' type='secondary'>
                                Creating AI that understands and responds to real-world environments.
                            </Heading>
                        </div>
                    </div>
                </div>
                <div className='alpha-perceptron-research-page__section__image'>
                    <img src={Image1} alt='AlphaPerceptron' />
                </div>
            </div>

            <div className='alpha-perceptron-research-page__section'>
                <div className='alpha-perceptron-research-page__section__image'>
                    <img src={Image4} alt='AlphaPerceptron' />
                </div>
                <div className='alpha-perceptron-research-page__section__content'>
                    <Heading theme='dark' size='h3' type='primary'>
                        AI-Generated Media & Entertainment
                    </Heading>
                    <Heading theme='dark' size='h6' type='secondary'>
                        Transforming storytelling through AI-driven content creation.
                    </Heading>
                    <div className='alpha-perceptron-research-page__section__content__flexRows'>
                        <div className='alpha-perceptron-research-page__section__content__flexRows__containers'>
                            <Heading theme='dark' size='h7' type='secondary'>
                                Training generative models to create high-quality cinematic experiences.
                            </Heading>
                        </div>
                        <div className='alpha-perceptron-research-page__section__content__flexRows__containers'>
                            <Heading theme='dark' size='h7' type='secondary'>
                                Exploring AI-assisted animation and scriptwriting.
                            </Heading>
                        </div>
                        <div className='alpha-perceptron-research-page__section__content__flexRows__containers'>
                            <Heading theme='dark' size='h7' type='secondary'>
                                Developing tools that empower creators to produce AI-generated films.
                            </Heading>
                        </div>
                    </div>
                </div>

            </div>
            <div className='alpha-perceptron-research-page__section'>
                <div className='alpha-perceptron-research-page__section__content'>
                    <Heading theme='dark' size='h3' type='primary'>
                        AI-Powered Drug Discovery
                    </Heading>
                    <Heading theme='dark' size='h6' type='secondary'>
                        Accelerating medical breakthroughs through AI-driven molecular modeling and predictive analytics.
                    </Heading>
                    <div className='alpha-perceptron-research-page__section__content__flexRows'>
                        <div className='alpha-perceptron-research-page__section__content__flexRows__containers'>
                            <Heading theme='dark' size='h7' type='secondary'>
                                Using AI to predict drug efficacy and optimize molecular structures.
                            </Heading>
                        </div>
                        <div className='alpha-perceptron-research-page__section__content__flexRows__containers'>
                            <Heading theme='dark' size='h7' type='secondary'>
                                Enhancing precision medicine through deep learning models.
                            </Heading>
                        </div>
                        <div className='alpha-perceptron-research-page__section__content__flexRows__containers'>
                            <Heading theme='dark' size='h7' type='secondary'>
                                Collaborating with researchers to fast-track drug development.
                            </Heading>
                        </div>
                    </div>
                </div>
                <div className='alpha-perceptron-research-page__section__image'>
                    <img src={Image2} alt='AlphaPerceptron' />
                </div>
            </div>
            <div className='alpha-perceptron-research-page__section-six'>
                <div className='alpha-perceptron-research-page__section-six__content'>
                    <Heading size='h3' type='primary' theme='dark'>
                        Why Our Research Matters?
                    </Heading>
                    <Heading size='h7' type='secondary' theme='dark'>
                        Our research is driven by the belief that AI should augment human potential, solve real-world challenges, and
                        unlock new frontiers in technology. Through our ongoing work, we aim to create ethical, impactful, and
                        forward-thinking AI solutions.
                    </Heading>
                    <br />
                    <div className='alpha-perceptron-research-page__section-six__content__heading'>
                        <img src={RocketIcon} alt='Stay Updated' />
                        <Heading size='h6' type='primary' theme='dark'>
                            Stay Updated
                        </Heading>
                    </div>
                    <Heading size='h7' type='secondary' theme='dark'>
                        As our research progresses, we will share updates, case studies, and technical insights. Stay
                        tuned for more developments.
                    </Heading>
                </div>
            </div>
            <div className='alpha-perceptron-research-page__section'>
                <div className='alpha-perceptron-research-page__section__content'>
                    <Heading theme='dark' size='h3' type='primary'>Interested in Collaborating?
                    </Heading>
                    <Heading theme='dark' size='h6' type='secondary'>We welcome partnerships with researchers, institutions, and industry leaders. If you’re interested in working with us, get in touch.
                    </Heading>

                </div>
                <div className='alpha-perceptron-research-page__section__form'>
                    <div className='alpha-perceptron-research-page__section__form__formContainer'>
                        <div className='alpha-perceptron-research-page__section__form__formContainer__form'>
                            <div className='alpha-perceptron-research-page__section__form__formContainer__form__inputContainer'>
                                <Input
                                    type="text"
                                    value={formData?.email}
                                    onChange={(e) => handleInputChange('email', e.target.value)}
                                    helperText={errorData?.email}
                                />
                                <Input
                                    type="text"
                                    placeholder="Your Experience"
                                    value={formData?.experience}
                                    onChange={(e) => handleInputChange('experience', e.target.value)}
                                    helperText={errorData?.experience}

                                />
                                <Input
                                    type="textarea"
                                    placeholder="Your Message"
                                    value={formData?.message}
                                    onChange={(e) => handleInputChange('message', e.target.value)}
                                    helperText={errorData?.message}

                                />
                                <Button disabled={isBtnDisabled} type='secondary' size='medium' icon={<ArrowForward />} onClick={handleSubmit}>
                                    {isLoading ? 'Sending...' : 'Submit'}
                                </Button>
                                {error && <p style={{ color: 'red', fontSize: '1.5vh', fontWeight: '400' }}>{error}</p>}

                            </div>

                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
}

export default ResearchPage;

